export default __webpack_public_path__ + "static/media/more_bg.ebd1743a.png";